import styled from 'styled-components';
import { Table as aTable } from 'antd';

export const Table = styled(aTable)`
  
`;
